import React from 'react';
import T from 'prop-types';
import {
  MetricCard,
  MetricHeader,
  MetricValue
} from 'routes/App/cashback/styles';
import {ButtonInfo} from 'components/buttons';

const CashbackMetricCard = ({
  icon,
  title,
  value,
  trendPercent,
  formatValue,
  tooltip
}) => {
  const formatted =
    typeof formatValue === 'function' ? formatValue(value) : value;
  const isPositive = trendPercent != null && trendPercent > 0;
  const trendLabel =
    trendPercent != null ? `(${isPositive ? '+' : ''}${trendPercent}%)` : null;

  return (
    <MetricCard>
      <MetricHeader>
        <span className='iconWrap'>{icon}</span>
        <span>{title}</span>
        <ButtonInfo className='OutlineBig ButtonInfoDrop Right0'>
          <div className='DropInfo DropInfoUpCashback'>{tooltip}</div>
        </ButtonInfo>
      </MetricHeader>
      <MetricValue>
        <span>{formatted}</span>
        {trendLabel && (
          <span className={`trend${isPositive ? '' : ' negative'}`}>
            {trendLabel}
          </span>
        )}
      </MetricValue>
    </MetricCard>
  );
};

CashbackMetricCard.propTypes = {
  icon: T.node,
  title: T.string.isRequired,
  value: T.oneOfType([T.string, T.number]),
  trendPercent: T.number,
  formatValue: T.func,
  tooltip: T.string.isRequired
};

CashbackMetricCard.defaultProps = {
  icon: null,
  value: 0,
  trendPercent: null,
  formatValue: null
};

export default CashbackMetricCard;
